/**
 * Dropdown list for Voluum lander tag API suggestions.
 * For Media Devoted | Created By Ciro Autiero
 */

import { cn } from '@/lib/utils';

import type { FC } from 'react';

export interface LanderTagSuggestionsListProps {
  isError: boolean;
  isFetching: boolean;
  options: string[];
  suggestions: string[];
  onPick: (tag: string) => void;
}

const LanderTagSuggestionsList: FC<LanderTagSuggestionsListProps> = ({
  isError,
  isFetching,
  options,
  suggestions,
  onPick,
}) => {
  if (isError) {
    return (
      <p className="px-3 py-2 text-xs text-destructive">
        Could not load tags from Voluum.
      </p>
    );
  }
  return (
    <>
      {isFetching && options.length === 0 ? (
        <p className="px-3 py-2 text-xs text-muted-foreground">Loading tags…</p>
      ) : null}
      {suggestions.map((t) => (
        <button
          key={t}
          type="button"
          className={cn(
            'flex w-full rounded-sm px-3 py-1.5 text-left text-sm',
            'hover:bg-accent hover:text-accent-foreground',
          )}
          onClick={() => onPick(t)}
        >
          {t}
        </button>
      ))}
      {!isFetching && suggestions.length === 0 ? (
        <p className="px-3 py-2 text-xs text-muted-foreground">
          {options.length === 0
            ? 'No preset tags. Press Enter to add.'
            : 'No matches. Press Enter to add a custom tag.'}
        </p>
      ) : null}
    </>
  );
};

export default LanderTagSuggestionsList;
